import React from "react";
import { Link } from "react-router-dom";
import ArgoCDArticle from "../components/ArgoCDArticle";
import { usePageTitle } from "../hooks/usePageTitle";
import "../assets/styles/TerraformArticle.scss";

function ArgoCDPage() {
  usePageTitle("GitOps avec ArgoCD");
  return (
    <div className="terraform-page">
      <Link to="/projects" className="article-back-btn">← Projets</Link>
      <ArgoCDArticle />
    </div>
  );
}

export default ArgoCDPage;
